export default "data:image/svg+xml,%3Cpath%20d%3D%22m7%2010%205%205%205-5z%22%20%2F%3E"